import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";
import { Dashboard } from "./Dashboard"; 

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_IMPERSONATE",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Bytt bruker',
    text: 'Bytt bruker',
    icon: 'user-switch',
    canShowOnDashboard: false,
    dashboard: Dashboard
});
